import { FC } from 'react';
import { Button, Svg } from '@altermaind/web/ui';
import { PropsArrow } from './types';

export const PrevArrow: FC<PropsArrow> = ({ onClick }) => {
  return (
    <Button
      variant='positive'
      onClick={onClick}
      style={{
        position: 'absolute',
        right: 40,
        bottom: '-45px',
        zIndex: 1,
        transform: 'translateY(-50%)',
      }}
      backgroundColor='transparent'
      aria-label='Next'
      minWidth='auto'
      height='fit-content'
      py='none'
      px='xxs'
    >
      <Svg name='chevronLeft' size='s' />
    </Button>
  );
};
